class LowestPriceGuaranteePopupTooltip extends Component {
    constructor(el) {
        super(el);
        this.tooltipTarget = document.querySelector('[data-guarantee-tooltip]');
        this.closer = this.$find('[data-guarantee-tooltip-close]');
        this.modalOpener = this.$find('[data-guarantee-popup-opener]');
        this.inner = this.$find('[data-guarantee-tooltip-inner]');
        this.activeClass = 'is-active';
        this.selectedLength = 4;
        this.init();
    }

    shouldInit() {
        return (!this.isTouchEnabled()) && (window.innerWidth >= 1024);
    }

    // is a touch device?
    isTouchEnabled() {
        return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
    }

    showTooltip() {
        const selection = document.getSelection();
        const shouldShow = selection.toString().length >= this.selectedLength;

        shouldShow && this.$el.classList.add(this.activeClass);
    }

    hideTooltip() {
        this.$el.classList.remove(this.activeClass);
    }

    init() {
        if (this.shouldInit()) {
            this.addEventListeners();
        }
    }

    addEventListeners() {
        this.lowestPriceGuaranteeOpener && this.lowestPriceGuaranteeOpener.addEventListener('click', () => this.openLowestPriceGuaranteePopup());
        this.tooltipTarget && this.tooltipTarget.addEventListener("pointerup", () => {
            this.showTooltip();
        });
        this.closer && this.closer.addEventListener('click', () => this.hideTooltip());
        this.modalOpener && this.modalOpener.addEventListener('click', () => {
            this.hideTooltip();
            EventBus.getInstance().dispatchEvent('showBasePopup', 'lowest-price-guarantee-popup');
        });
    }
}